import React, { useState, useEffect } from 'react'
import vidimage from './../img/vidimage.png'
import Api from '../common/api'

const Videos = () => {

  const lang = localStorage.getItem("lang");

  React.useEffect(() => {
    Api.get("/videos/list").then((res) => {
      console.log(res.data.items);
      setVideos(res.data.items)
    });
  }, []);


  function Iframe(props) {
    return (<div dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : "" }} />);
  }
  const [videos, setVideos] = useState([
    {
      id: 1,
      Title: "buproject test",
      Link: "",
      img: vidimage,
    }
  ])

  return (
    <>
      <div className="video-container container-sm">
        {videos ? videos.map((video) => {
          const iframe = '<iframe width="560" height="315" src="https://www.youtube.com/embed/' + video.Link + '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
          return (
            lang == "en" ? (
              video.Title_En ? (
            <>
              <div className="iframe-container">
                <Iframe iframe={iframe} />
                <h5 style={{ marginTop: '20px', fontWeight: '300' }} >{video.Title_En}</h5>
              </div>
            </>
            ):""
            ):(
              video.Title ? (

              <>
              <div className="iframe-container">
                <Iframe iframe={iframe} />
                <h5 style={{ marginTop: '20px', fontWeight: '300' }} >{video.Title}</h5>
              </div>
            </>
              ):""
            )
          )
        }) : null}

      </div>
    </>
  )
}

export default Videos
